import { useLocation } from 'react-router'

import { PAGE_META } from '@/app/router/pageMeta'

import { PeriodControl } from './PeriodControl'
import s from './Topbar.module.css'

export function Topbar() {
  const { pathname } = useLocation()
  const meta = PAGE_META[pathname] ?? { title: 'Kepler Vision', subtitle: '', showPeriod: false }

  return (
    <header className={s.topbar}>
      {/* Внутренняя часть ограничена шириной контента, фон шапки — на всё окно. */}
      <div className={s.inner}>
        <div className={s.title}>
          <h1>{meta.title}</h1>
          {meta.subtitle && <div className={s.subtitle}>{meta.subtitle}</div>}
        </div>
        {meta.showPeriod && <PeriodControl />}
      </div>
    </header>
  )
}
